import type { Address } from '@src/core/buyerApiClient';
import { initialAddressValues } from '@src/common/auth';

export function buildForeignAddress(zipCode: string | null): Address {
  return { ...initialAddressValues, zipCode };
}
